/**
 * Formatting + derivation helpers — ported verbatim from the prototype's Component
 * helpers (SK Hospitality.dc.html: inr/fmtClock/fmt12 ~1173-1174, slug/resourceId ~1371-1372).
 */

/** ₹ with en-IN grouping, e.g. 184500 → "₹1,84,500". */
export const inr = (n: number): string => '₹' + Math.round(n).toLocaleString('en-IN');

/** minutes-since-midnight → "HH:MM" (24h, wraps at 24h). */
export const fmtClock = (m: number): string => {
  const h = Math.floor(m / 60) % 24;
  const mm = m % 60;
  return String(h).padStart(2, '0') + ':' + String(mm).padStart(2, '0');
};

/** The actual current wall-clock time as "HH:MM" (24h, local) — for timestamping
 *  real events (SUKI feed entries, "seated since") so they match the clock on
 *  the wall, not a simulated/frozen minute counter. */
export const fmtNow = (): string => {
  const d = new Date();
  return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
};

/** minutes-since-midnight → "h:MM AM/PM". */
export const fmt12 = (min: number): string => {
  const m = min % (24 * 60);
  let h = Math.floor(m / 60);
  const mm = m % 60;
  const ap = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return h + ':' + String(mm).padStart(2, '0') + ' ' + ap;
};

/** ISO datetime → 'h:mm AM/PM'; non-ISO (e.g. a display string already) passes through unchanged. */
export const displayTime = (time: string): string => {
  if (!time.includes('T')) return time;
  const d = new Date(time);
  if (isNaN(d.getTime())) return time;
  let h = d.getHours();
  const m = d.getMinutes().toString().padStart(2, '0');
  const ap = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${h}:${m} ${ap}`;
};

/** Slugify a single resource-id segment (lowercase, & → and, strip non-alnum, cap 18). */
export const slug = (s: string): string =>
  (s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '').slice(0, 18) || 'x';

/**
 * Calendar resource id: org_location_section_table.
 * Location name's venue segment is the part after "·" (e.g. "Arabian Garden · Seafood" → "seafood").
 */
export const resourceId = (org: string, locationName: string, sectionName: string, label: string): string =>
  [slug(org), slug(locationName.split('·').pop() || locationName), slug(sectionName), slug(label)].join('_');
